
export function formatDurationTimestamp(duration){
	let time= Math.floor(duration)
    let minutes=Math.floor(time / 60)
    let seconds=time - minutes * 60
    seconds = seconds < 10 ? '0' + seconds : seconds
    return `${minutes}:${seconds}`
}